import _toConsumableArray from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
/**
 * Returns all the days belonging to the calendar by merging the days in the
 * weeks for each month.
 */
export function getDays(calendarMonths) {
  var initialDays = [];
  return calendarMonths.reduce(function (days, month) {
    var initialDays = [];
    var weekDays = month.weeks.reduce(function (weekDays, week) {
      return [].concat(_toConsumableArray(weekDays), _toConsumableArray(week.days));
    }, initialDays);
    return [].concat(_toConsumableArray(days), _toConsumableArray(weekDays));
  }, initialDays);
}